module.exports = __webpack_public_path__ + "static/media/trociny.41437f0d.jpg";